const notice = [
    {
        id: 601,
        no: 16,
        title: '이용약관 개정 안내',
        txt: `안녕하세요.
채선당 도시락&샐러드 입니다.

항상 저희 채선당 도시락&샐러드를 이용해 주시는 회원 여러분께 감사 말씀 드립니다.
2026년부터 채선당 도시락&샐러드 예치금 결제 수단이 중단되어 안내드립니다.

이용약관 제26조에 따라, 사용 불가 결제 수단에 남아 있는 예치금은 2025년 12월 31일 오전까지 사용·환불 접수가 가능하며, 환불 접수 시 2025년 12월 31일에 순차적으로 환불 처리될 예정입니다.
환불 접수를 하지 않은 경우, 미사용 예치금은 2025년 12월 31일 정오에 자동 소멸처리 될 예정입니다.

보유하고 계신 예치금은 소멸 예정일 최소 30일 전 SMS를 통해 안내 드릴 예정으로
고객님의 보다 편리하고 합리적인 이용을 위해 최선을 다하겠습니다.

감사합니다.
            `,
        day: '2025.11.25',
    },
    {
        id: 602,
        no: 15,
        title: '추석 연휴 배송 안내',
        txt: `원하시는 날짜에 정확히 받아보실 수 있도록
아래 주문 마감일과 수령일을 꼭 확인해 주세요.


■ 택배 배송

마지막 수령일 : 10/2(목)

주문 마감일 : 9/30(화)

■ 새벽 배송`,
        day: '2025.09.29',
    },
    {
        id: 603,
        no: 14,
        title: '환경 보호를 위한 변경사항',
        txt: `1) 온라인 거래명세서 제공
자연을 생각하여 거래명세서는 홈페이지와 송장으로 대체합니다.

◎ 거래명세서 확인방법
[내정보-주문/배송 조회 및 변경-상세 정보 보기-거래명세서 보기] 혹은 송장에서 확인 가능합니다.

2) 소용기 뚜껑 제공
반찬 용기의 크기에 맞게 선택했던 기존 방식에서, '소용기 뚜껑'을 선택하는 방식으로 변경되었습니다.
*냉장국 제품의 경우 파손 위험을 방지하고자 대용기 뚜껑을 제공합니다.
`,
        day: '2025.01.24',
    },
    {
        id: 604,
        no: 13,
        title: '시스템 오류 안내',
        txt: `안녕하세요.
채선당 도시락&샐러드입니다.

12월 31일 시스템 오류로 인해 고객님께 혼선을 드린 점 대단히 죄송합니다.
당일 다수 고객님들의 동시 접속으로 서버가 원활하지 않은 오류가 발생했습니다.
현재는 긴급 점검이 완료되어 정상적으로 서비스 이용이 가능합니다.

해당 시스템 오류 관련하여 추가 문의사항이 있으실 경우 
고객센터로 연락 주시기 바랍니다.

다시 한 번 이용에 불편함을 드려서 죄송합니다.
앞으로 더 나은 서비스를 제공해 드릴 수 있도록 노력하는 채선당 도시락&샐러드가 되겠습니다.

감사합니다.
`,
        day: '2025.01.02',
    },
    {
        id: 605,
        no: 12,
        title: '배추 가격 폭등으로 인한 판매 변경 안내',
        txt: `저희 채선당 도시락&샐러드는
우수한 품질의 도시락을 합리적인 가격으로
제공하기 위해 최선의 노력을 다하고 있습니다.
최근 배추 수급이 어려워
일부 해당 원재료가 사용된 제품일 경우
대체 제품으로 출고될 수 있는 점 안내드립니다,

정상적으로 농산물 수급이 가능하고,
품질이 보증되는 시점에
신속히 재안내드리겠습니다.

고객님의 따듯한 이해 부탁드리며,
앞으로도 끊임없이 노력하겠습니다.

감사합니다.
            `,
        day: '2024.09.30',
    },
    {
        id: 606,
        no: 11,
        title: '개인정보보호법 개정에 따른 장기 미접속자 회원 정책 변경 안내',
        txt: `개인정보보호법 개정에 따른 장기 미접속자 회원 정책 변경 안내
2023년 9월 15일 개인정보보호법 개정에 따라 '개인정보 유효기간제(개정 전 39조의 6)'가 폐지되었습니다.

1. 적용일자
    - 약관 변경일 : 2024년 4월 1일(월)
    - 시스템 변경일 : 2024년 5월 1일(수)

2. 변경사항
    - 기존 : 회사는 사용자가 선택한 개인정보 유효기간(1년 / 3년 / 5년)동안 로그인 이력이 없는 회원에 대하여 휴면 회원으로 전환하며 휴면회원의 개인정보를 분리하여 별도로 보관합니다.
    - 변경 : 개인정보 유효기간제 폐지

3. 기타 안내
    - 전환에 동의하지 않거나 회원탈퇴를 원하시는 경우, 마이페이지에서 탈퇴신청이 가능하며, 그 외 문의는 고객센터로 연락 주시면 처리 해 드리도록 하겠습니다.
`,
        day: '2024.03.28',
    },
    {
        id: 607,
        no: 10,
        title: '주문 마감시간 변경 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

보다 나은 품질의 반찬을 더욱 신선하게 전달해 드리기 위해
2024년 2월 29일(목)부터 당일출고 주문 마감시간이
아래와 같이 변경됩니다.

[변경 전] 오전 9시 30분
[변경 후] 오전 7시

오전 7시 까지 결제 완료 시, 다음날 도시락을 받으실 수 있습니다.

이용에 참고 부탁드리며, 더 나은 품질과 서비스로 보답하는
채선당 도시락&샐러드가 되겠습니다.

감사합니다.
            `,
        day: '2024.02.23',
    },
    {
        id: 608,
        no: 9,
        title: '제조시설 이전으로 인한 배송불가 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀드립니다.

고객님들께 더욱 믿을 수 있는 먹거리, 안전한 먹거리를 전달하기 위해
채선당 도시락&샐러드의 반찬 제조시설을 새롭게 이전하게 되었습니다.

따라서 아래 날짜에 반찬 수령이 불가하오니, 고객님들의 너그러운 양해 부탁드립니다.

[수령 불가] 10월 30일(월)

[수령 가능] 10월 31일(화) ~

감사합니다.
`,
        day: '2023.10.31',
    },
    {
        id: 609,
        no: 8,
        title: '기상 악화로 인한 배송지연 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

제 6호 태풍 '카눈' 북상으로 금일 전국 곳곳의 많은 양의 비가 예보되어 있습니다.
이로 인하여 도로 침수 및 통제가 발생하여 일부 지역에서의 배송이 지연될 수 있음을 안내드립니다.

최대한 안전하게 배송이 이루어질 수 있도록 노력하는 채선당 도시락&샐러드가 되겠습니다.
다만, 도로 상황에 따라 정상 배송이 어려울 수 있는 점 양해 부탁드립니다.

감사합니다.
`,
        day: '2023.08.10',
    },
    {
        id: 610,
        no: 7,
        title: '기상 악화로 인한 배송지연 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

금일 전국 곳곳의 많은 양의 비가 예보되어 있습니다.
이로 인하여 도로 침수 및 통제가 발생하여 일부 지역에서의 배송이 지연될 수 있음을 안내드립니다.

최대한 안전하게 배송이 이루어질 수 있도록 노력하는 채선당 도시락&샐러드가 되겠습니다.
다만, 도로 상황에 따라 정상 배송이 어려울 수 있는 점 양해 부탁드립니다.

감사합니다.
`,
        day: '2023.07.11',
    },
    {
        id: 611,
        no: 6,
        title: '주문 마감시간 변경 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

2022년 12월 19일부터 주문 마감시간이
아래와 같이 변경됩니다.

[변경 전] 오전 10시

[변경 후] 오전 9시 30분

오전 9시 30분까지 결제 완료 시,
다음날 도시락을 받으실 수 있습니다.
이용에 참고 부탁드립니다.

감사합니다.
`,
        day: '2022.12.28',
    },
    {
        id: 612,
        no: 5,
        title: '이용약관 개정 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

항상 저희 채선당 도시락&샐러드를 이용해 주시는 회원 여러분께 감사 말씀 드립니다.
채선당 도시락&샐러드 이용약관의 일부 내용이 변경되어 안내드립니다.

이용약관 제 25조에 따라 2023년 12월 31일(일) 까지 적립된 적립금 중 미사용 분에 대하여 2024년 12월 31일(화) 에 자동 소멸처리 될 예정입니다.
또한, 2024년 1월 1일(월) 부터 지급되는 적립금의 사용 유효기한은 1년 이며, 1년이 되는 시점에 자동 소멸처리 될 예정입니다.

보유하고 계신 적립금이 소멸하기 최소 30일 전 이메일 또는 SMS, 카카오톡을 통해 안내를 드릴 예정이며
고객님의 편하고 합리적인 이용을 위해 최선을 다하겠습니다.

감사합니다.
`,
        day: '2022.12.16',
    },
    {
        id: 613,
        no: 4,
        title: '주문 마감시간 변경 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

2022년 9월 19일부터 주문 마감시간이
아래와 같이 변경됩니다.

[변경 전] 오전 9시

[변경 후] 오전 10시

오전 10시까지 결제 완료 시,
다음날 도시락을 받으실 수 있습니다.
이용에 참고 부탁드립니다.

감사합니다.
`,
        day: '2022.09.19',
    },
    {
        id: 614,
        no: 3,
        title: '9/9 새벽배송 주문마감 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

추석 제품 주문량 폭증으로 인하여 9월 9일(금) 수령이 조기 마감되었습니다.
현재 추석 연휴에 가장 가까운 수령 가능 일자는 9월 8일(목) 입니다.

9월 7일(수) 오전 9시까지 주문하시면, 9월 8일(목) 새벽배송으로 받아보실 수 있습니다.

이번 추석 음식은 채선당 도시락&샐러드에 맡겨주신 만큼,

믿고 드실 수 있는 음식으로 보답하겠습니다.
감사합니다.
`,
        day: '2022.09.09',
    },
    {
        id: 615,
        no: 2,
        title: '시스템 오류 안내',
        txt: `채선당 도시락&샐러드를 이용해 주시는
고객님들께 안내 말씀 드립니다.

8월 31일 시스템 오류로 인해 고객님께 혼선을 드린 점 대단히 죄송합니다.
당일 다수 고객님들의 동시 접속으로 서버가 원활하지 않은 오류가 발생했습니다.
현재는 긴급 점검이 완료되어 정상적으로 서비스 이용이 가능합니다.

해당 시스템 오류 관련하여 추가 문의사항이 있으실 경우 
고객센터로 연락 주시기 바랍니다.

다시 한 번 이용에 불편함을 드려서 죄송합니다.
앞으로 더 나은 서비스를 제공해 드릴 수 있도록 노력하는 채선당 도시락&샐러드가 되겠습니다.
감사합니다.
`,
        day: '2022.08.19',
    },
    {
        id: 616,
        no: 1,
        title: '원재료 변경 안내(현미유)',
        txt: `더 건강하고, 맛있는 도시락을 전해드리기 위해
채선당 도시락&샐러드에서 사용하는 원재료 중 [현미유]를
태국산 현미를 국내에서 제조한 현미유로 변경하였습니다.

고객님들께 더 나은 품질의 도시락을 전달하기 위해 끊임없이 노력하는
채선당 도시락&샐러드가 되도록 하겠습니다.
`,
        day: '2022.05.20',
    },
]

export default notice;